import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.button`
  padding-left: 2px;
  padding-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default Atom({ type: 'button', dataType: 'object', template })